module.exports = __webpack_public_path__ + "img/AGR.166bcf28.png";